import axiosInstance from "./axiosInstance";

// ==========================================
// GET CITIES
// ==========================================

export const getCities = async () => {
  try {
    const response = await axiosInstance.get(
      `/cities?fields[0]=name&fields[1]=slug&populate[country][fields][0]=name&populate[country][fields][1]=slug`
    );

    return response?.data?.data || [];
  } catch (error) {
    console.error("Error fetching cities:", error);
    return [];
  }
};


// ==========================================
// GET PRODUCTS FOR SEARCH
// ==========================================

export const getSearchProducts = async () => {
  try {
    const response = await axiosInstance.get(
      `/product-details?filters[product_groups][name][$eq]=show_in_search` +
      `&fields[0]=id` +
      `&fields[1]=title` +
      `&fields[2]=slug` +
      `&populate[images][fields][0]=url` +

      // CITY
      `&populate[city][fields][0]=name` +
      `&populate[city][fields][1]=slug` +

      // CITY -> COUNTRY
      `&populate[city][populate][country][fields][0]=name` +
      `&populate[city][populate][country][fields][1]=slug` +

      // SUB PRODUCT
      `&populate[sub_product][fields][0]=slug` +

      // SUB PRODUCT -> PRODUCTS
      `&populate[sub_product][populate][products][fields][0]=slug`
    );

    return response?.data?.data || [];
  } catch (error) {
    console.error("Error fetching search products:", error);
    return [];
  }
};